import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { name: "网红翻车", href: "/category/influencer-flop" },
  { name: "明星黑料", href: "/category/celebrity-scandal" },
  { name: "社会热点", href: "/category/social-hot" },
  { name: "每日吃瓜", href: "/category/daily-gossip" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 text-foreground-950 hover:opacity-80 transition-opacity"
          >
            <span className="font-heading text-xl md:text-2xl font-bold tracking-tight whitespace-nowrap">
              911<span className="text-primary-500">吃瓜网</span>
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                  location.pathname === link.href
                    ? "text-primary-500"
                    : scrolled
                    ? "text-foreground-700 hover:text-primary-500"
                    : "text-white/90 hover:text-white"
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="text-sm font-medium transition-colors duration-200 whitespace-nowrap text-foreground-700 hover:text-primary-500"
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-950"
            aria-label="Toggle menu"
          >
            <i
              className={`text-xl ${
                mobileOpen ? "ri-close-line" : "ri-menu-line"
              }`}
            ></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200 py-4">
            <div className="flex flex-col gap-3 px-2">
              {navLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`text-sm font-medium px-3 py-2 rounded-lg transition-colors ${
                    location.pathname === link.href
                      ? "bg-primary-100 text-primary-600"
                      : "text-foreground-700 hover:bg-background-100"
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <Link
                to="/about"
                className="text-sm font-medium px-3 py-2 rounded-lg text-foreground-700 hover:bg-background-100 transition-colors"
              >
                关于我们
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}